<script setup lang="ts">
const props = withDefaults(defineProps<{
  title: string;
  price?: string;
  monthPrice?: string;
  offPrice?: string;
  label?: string;
  isOpen?: boolean;
  loading?: boolean;
}>(), {
  price: '',
  monthPrice: '',
  offPrice: '',
  label: '',
  isOpen: false,
  loading: false,
});

const emit = defineEmits<{
  'click': [];
}>();

const onClick = () => {
  if (props.loading) return;
  emit('click');
};
</script>

<template>
  <div>
    <div class="flex gap-16 px-16">
      <div
        v-if="label"
        class="rounded-t-[5px] bg-primary-300 px-16 py-6 text-16 font-bold text-white"
      >
        {{ label }}
      </div>

      <div
        v-if="offPrice && isOpen"
        class="ml-auto rounded-t-[5px] bg-black px-16 py-6 text-16 font-bold text-white"
      >
        {{ offPrice }}
      </div>
    </div>

    <button
      v-if="!isOpen"
      type="button"
      class="flex w-full items-center justify-between gap-16 rounded-[5px] border border-primary-200 p-20 hover:border-primary-300 hover:bg-primary-300"
      :class="{
        'pointer-events-none opacity-50': loading,
      }"
      data-testpl="checkout-period-btn"
      @click="onClick"
    >
      <span class="text-left text-18 font-bold">
        {{ title }}
      </span>

      <span
        v-if="price"
        class="flex gap-x-12 gap-y-4 text-right text-12"
      >
        <span
          v-if="monthPrice"
          class="line-through opacity-50"
        >
          {{ monthPrice }}
        </span>

        <span>{{ price }}</span>
      </span>
    </button>

    <div
      v-else
      class="rounded-[5px] border border-primary-500 p-20"
      data-testpl="checkout-period"
    >
      <div class="flex items-start justify-between gap-16">
        <span class="text-left text-18 font-bold text-primary-500">
          {{ title }}
        </span>

        <div
          v-if="price"
          class="flex flex-col gap-x-12 gap-y-4 text-right text-18"
        >
          <span class="font-bold text-primary-500">
            {{ price }}
          </span>

          <span
            v-if="monthPrice"
            class="line-through opacity-50"
          >
            {{ monthPrice }}
          </span>
        </div>
      </div>

      <div class="mt-28">
        <slot />
      </div>
    </div>
  </div>
</template>
